<template>
  <div class="csr-page">
    <div class="hero-section">
      <div class="hero-image">
        <img src="https://img2.xwxwxw.com.cn/images/2000_800.webp" alt="企业社会责任">
      </div>
      <div class="csr-content Pt75">
        <div class="box">
          <div class="content-wrapper">
            <!-- 支持当地青年 -->
            <div class="content-block">
              <div class="text-content">
                <h2>支持当地青年</h2>
                <p>我们知道，明天的力量始于今天孩子们的梦想。这就是为什么Waykar很荣幸赞助南卡罗来纳州加夫尼市的一支当地青少年足球队。看到孩子们自信而坚定地踏上球场，提醒我们团队合作、坚持不懈和热情可以在体育运动和生活中产生影响。我们很感激能成为他们旅程中的一小部分，在他们追逐目标的时候为他们加油。</p>
              </div>
              <div class="image-content">
                <img src="https://img2.xwxwxw.com.cn/images/Waykar_sponsored_football_game.webp" alt="支持当地青年">
              </div>
            </div>

            <!-- 通过庭院销售回馈社会 -->
            <div class="content-block reverse">
              <div class="text-content">
                <h2>通过庭院销售回馈社会</h2>
                <p>我们也想以更个人化的方式回馈社会——让邻居们能够使用到优质产品。最近，Waykar举办了一场免费的庭院销售活动，向当地家庭提供了退货但仍然完全可用的产品。原本可能闲置的库存找到了新的用途，进入了真正需要它们的家庭。那天的笑容、感激和建立的联系提醒我们，回馈不仅仅是给予什么，而是要在社区中建立信任、关怀和持久的关系。</p>
              </div>
              <div class="image-content">
                <img src="https://img2.xwxwxw.com.cn/images/Waykar_free_yard_sale.webp" alt="庭院销售回馈社会">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

</template>

<script>
export default {
  name: 'CSRPage'
};
</script>

<style scoped>
/* Base Styles & Utilities */
.Pt75 {
  padding-top: 75px;
  padding-bottom: 75px;
}

.box {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

/* 顶部大图区域 - 全屏铺满 */
.hero-section {
  width: 100%;
  position: relative;
  margin-bottom: 0;
}

.hero-image {
  width: 100%;
  height: 100%;
}

.hero-image img {
  width: 100%;
  object-fit: cover;
  object-position: center;
}

/* 内容区域 */
.csr-content {
  background-color: #f8f9fa;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.content-block {
  display: flex;
  gap: 30px;
  background-color: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.content-block:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text-content h2 {
  font-size: 28px;
  font-weight: 600;
  color: #479759;
  margin-bottom: 20px;
}

.text-content p {
  font-size: 16px;
  color: #555;
  line-height: 1.7;
  text-align: justify;
}

.image-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
}

.image-content img {
  width: 100%;
  object-fit: cover;
  object-position: center;
}

/* 反转布局 */
.content-block.reverse {
  flex-direction: row-reverse;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero-section {
    height: 300px;
  }
  
  .content-block {
    flex-direction: column;
  }
  
  .content-block.reverse {
    flex-direction: column;
  }
  
  .text-content h2 {
    font-size: 24px;
  }
  
  .text-content p {
    font-size: 15px;
  }
}

@media screen and (max-width: 48rem) {
  .Pt75 { 
    padding-top: 1.5rem; 
    padding-bottom: 1.5rem; 
  }
  
  .box { 
    padding: 0 0.625rem; 
  }
  
  .hero-section {
    height: 200px;
  }
  
  .content-wrapper {
    gap: 1.5rem;
  }
  
  .content-block {
    padding: 1.25rem;
    border-radius: 0.5rem;
  }
  
  .text-content {
    margin-bottom: 1rem;
  }
  
  .text-content h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  .text-content p {
    font-size: 0.875rem;
    line-height: 1.6;
  }
  
  .image-content {
    border-radius: 0.375rem;
    min-height: 200px;
  }
}
</style>